import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ToasterMessages } from 'src/app/shared/constants/constants';
import { CargoheatingCommonService } from 'src/app/shared/service/cargo-heating-service/cargoheating-common.service';
import { RequestFormService } from 'src/app/shared/service/requestForm/request-form.service';
import { CustomInputModule } from "src/app/shared/components/custom-input/custom-input.module";
import { MaterialModule } from "src/app/shared/material/material.module";
import { CARGO_HEATING_SEGMENTS, toCargoHeatingSegmentApiValue, canonicalizeCargoHeatingSegment } from "../../cargo-heating-segments";

@Component({
  selector: 'app-new-requests-form',
  templateUrl: './new-requests-form.component.html',
  styleUrls: ['./new-requests-form.component.scss'],
})
export class NewRequestsFormComponent implements OnInit {
  newRequestForm!: FormGroup;
  formSubmitted = false;
  /** Single source of truth for Segment values, shared with all Cargo Heating filters. */
  segmentOptions: string[] = CARGO_HEATING_SEGMENTS;

  constructor(
    private fb: FormBuilder,
    private commonService: CargoheatingCommonService,
    private toastr: ToastrService,
    private router: Router,
     private requestFormService: RequestFormService,
  ) {
    this.newRequestForm = this.fb.group({
      vessel_name: ['', Validators.required],
      vessel_imo: ['', Validators.required],
      segment: ['', Validators.required],
      gen_oil_grade: ['', Validators.required],
      voy_num: ['', Validators.required],

      // Others fields
      // totalTanks: [''],
      startLatitude: [''],
      startLongitude: [''],
      endLatitude: [''],
      endLongitude: [''],
      startPort: [''],
      destinationPort: [''],
      speed: [''],
      forecastDays: [''],
      temperatureLogTime: [''],
      deckHeatExchanger: [''],
      boilerLoad: [''],
      deckSteamPressure: [''],
      noOfTksInCirculation: ['']
    });
  }

  ngOnInit(): void {
    this.commonService.getFleetViewRowDat().subscribe(data => {
      if (data) {
        this.populateForm(data);
      }
    });
  }

  populateForm(data: any): void {
    this.newRequestForm.patchValue({
      vessel_name: data.vessel_name,
      vessel_imo: data.vessel_imo,
      segment: canonicalizeCargoHeatingSegment(data.segment) || data.segment,
      gen_oil_grade: data.gen_oil_grade,
      voy_num: data.voy_num,
      ...data.others  
    });
  }

  submitClick(): void {
    this.formSubmitted = true;

    if (this.newRequestForm) {
      const formValue = this.newRequestForm.getRawValue();

      // Final payload in required backend structure
      const finalPayload = {
        vessel_name: formValue.vessel_name,
        vessel_imo: formValue.vessel_imo,
        segment: toCargoHeatingSegmentApiValue(formValue.segment),
        gen_oil_grade: formValue.gen_oil_grade,
        voy_num: formValue.voy_num,
        others: {
          // totalTanks: formValue.totalTanks,
          startLatitude: formValue.startLatitude,
          startLongitude: formValue.startLongitude,
          endLatitude: formValue.endLatitude,
          endLongitude: formValue.endLongitude,
          startPort: formValue.startPort,
          destinationPort: formValue.destinationPort,
          speed: formValue.speed,
          forecastDays: formValue.forecastDays,
          temperatureLogTime: formValue.temperatureLogTime,
          deckHeatExchanger: formValue.deckHeatExchanger,
          boilerLoad: formValue.boilerLoad,
          deckSteamPressure: formValue.deckSteamPressure,
          noOfTksInCirculation: formValue.noOfTksInCirculation
        }
      };

      console.log('Payload to backend:', JSON.stringify(finalPayload, null, 2));

      this.commonService.myrequestdataInsert(finalPayload).subscribe({
        next: (res: any) => {
          this.toastr.success(res.message || ToasterMessages.SubmitForm);
          this.clearClick();
        },
        error: (error) => {
          console.error('Error submitting form', error);
          this.toastr.error('Error submitting form');
        }
      });
    } else {
      this.toastr.info(ToasterMessages.FormValidation);
    }
  }

  clearClick(): void {
    this.formSubmitted = false;
    this.newRequestForm.reset();
    this.commonService.clearFleetViewRowDat();
  }

  isDarkMode(): boolean {
    return this.requestFormService.isDarkMode();
  }
}
